import React, { useContext, useState, useEffect } from "react";
import {
  Stack,
  Grid2 as Grid,
  Typography,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { useMutation } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";

//Srcs
import "../../../../Style/dialogStyle.scss";
import { AuthContext } from "../../../../Context/AuthContext";
import { translateLauguage } from "../../../../Function/Translate";
import { FINISH_CLASS } from "../../../../Schema/Student";

import DatePickerForDialog from "../../../Include/SelecteDatePicker/DatePickerForDialog";
import moment from "moment";

export default function StudentFinishClass({
  open,
  handleClose,
  setRefetch,
  editData,
  rowId,
  enrollmentTypeAction
}) {
  // console.log("editDataEnrollAction", editData);
  // console.log("isDropOut", editData?.is_drop_out);

  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(false);

  //======================== change class =========================
  const [finishClass] = useMutation(FINISH_CLASS, {
    onCompleted: ({ finishClass }) => {
      // console.log("finishClass::", finishClass);
      setLoading(false);
      if (finishClass?.is_success === true) {
        setAlert(true, "success", finishClass?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", finishClass?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    certificate_offer_status: Yup.string(),
    is_finished_class: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      certificate_offer_status: "",
      is_finished_class: true,
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      // console.log("va;ues",editData?._id,values?.changeToClassId)
      setLoading(true);
      finishClass({
        variables: {
          // id: editData?._id,
          id: enrollmentTypeAction === "student_page" ? rowId : editData?._id,
          input: {
            certificate_offer_status: values?.is_finished_class === false ? null : values?.certificate_offer_status,
            is_finished_class: values?.is_finished_class,
          },
        },
      });
    },
  });

  const {
    errors,
    touched,
    values,
    handleSubmit,
    getFieldProps,
    resetForm,
    setFieldValue,
  } = formik;

  useEffect(() => {
    // setFieldValue("is_finished_class", editData?.is_finished_class);
    setFieldValue(
      "certificate_offer_status",
      editData?.certificate_offer_status ?? ""
    );
  }, [open]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography
              className={language === "en" ? "dialog-title" : "dialog-title-kh"}
            >
              {t("finish_class")}
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("thead_status")}
                </Typography>
                <FormControl size="small" fullWidth>
                  <Select
                    value={values?.is_finished_class}
                    onChange={(e) =>
                      setFieldValue("is_finished_class", e.target.value)
                    }
                  >
                    <MenuItem value={false}>{t("studying")}</MenuItem>
                    <MenuItem value={true}>{t("finish_class")}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 12 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("after_finish")}
                </Typography>
                <FormControl size="small" fullWidth>
                  <Select
                    value={values?.certificate_offer_status}
                    onChange={(e) =>
                      setFieldValue("certificate_offer_status", e.target.value)
                    }
                  >
                    <MenuItem value="Next_Class">{t("next_class")}</MenuItem>
                    <MenuItem value="Offer">{t("certificate_offer")}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
      <DialogActions>
        <Grid size={{ xs: 12 }} className="create-container">
          {loading ? (
            <Button
              className={language === "kh" ? "btn-create-kh" : "btn-create"}
              fullWidth
            >
              {t("loading")}
            </Button>
          ) : (
            <Button
              className={language === "kh" ? "btn-create-kh" : "btn-create"}
              fullWidth
              onClick={handleSubmit}
            >
              {t("btn-done")}
            </Button>
          )}
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
